import { Nomenclature } from '@feature/nomenclature';
import { IdentityRequest } from '@feature/utils';

export interface PublicationImpactFactor {
  metrics: ImpactFactor | null;
  journal: SmallJournal | null;
  rank: ImpactFactorRank | null;
  temporary: boolean;
}

export interface PublicationInfluence {
  metrics: ArticleInfluenceScore | null;
  rank: ArticleInfluenceRank | null;
  journal: SmallJournal | null;
  temporary: boolean;
}

export interface ArticleInfluenceRank {
  id: number;
  quarterly: string;
  rank: number;
  rankOf: number;
  year: number;
  wosIndex: Nomenclature | null;
  wosCategory: Nomenclature | null;
  suppressed: boolean;
}

export interface ImpactFactorRank {
  id: number;
  quarterly: string;
  rank: number;
  rankOf: number;
  year: number;
  value: number;
  wosIndex: Nomenclature | null;
  wosCategory: Nomenclature | null;
  suppressed: boolean;
}

export interface ArticleInfluenceScore {
  journalId: string;
  year: number;
  articleInfluenceScore: number;
}

export interface JournalAisMetric {
  id: number;
  journalId: string;
  year: number;
  articleInfluenceScore: number;
}

export interface ImpactFactor {
  id: number;
  journalId: string;
  year: number;
  impactFactor5Years: number;
  impactFactorWithoutSelfCitations: number;
  impactFactor: number;
  suppressed: boolean;
}

export interface BestQuater {
  quater: string;
  type: string;
}

export const issnCategoryList = ['PRINT', 'ELECTRONIC', 'LINK'] as const;
export type IssnCategory = (typeof issnCategoryList)[number];

export const quarterList = ['Q1', 'Q2', 'Q3', 'Q4'] as const;
export type Quarter = (typeof quarterList)[number];

export interface Issn {
  id: number;
  code: string;
  category: IssnCategory;
}

export interface Publisher {
  id: number;
  title: string;
}

export interface SmallJournal {
  id: number;
  title: string;
  wosId: string | null;
}

export interface Journal {
  id: number;
  title: string;
  creationDate: string;
  language: Nomenclature;
  publisher: Publisher;
  bdis: Nomenclature[];
  issn: Issn[];

  isUmfstOwned?: boolean;
  wosId?: string;
}

export interface IssnRequest {
  code: string;
  category: IssnCategory;
}

export interface JournalRequest {
  title: string;
  language: IdentityRequest;
  publisher: IdentityRequest;
  bdis: IdentityRequest[];

  issn: IssnRequest[];
}

export interface JournalAisMetric {
  id: number;
  journalId: string;
  year: number;
  articleInfluenceScore: number;
}

export interface JournalAisRank {
  id: number;
  quarterly: string;
  rank: number;
  rankOf: number;
  year: number;
  value: number;
  wosIndex: Nomenclature | null;
  wosCategory: Nomenclature | null;
  suppressed: boolean;
}
